import { Box, ListItem, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function SendToReviewScheduleRow({ schedule, color = "text.secondary" }) {
    const { title, code } = schedule
    return (
        <ListItem
            data-cy="send-to-review-schedule-row"
            sx={{ borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}
        >
            <Stack direction="row" spacing={2} alignItems="center" sx={{ width: 1 }}>
                <Iconify icon="quill:paper" sx={{ width: 24, height: 24, color }} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" noWrap>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        #{code}
                    </Typography>
                </Box>
            </Stack>
        </ListItem>
    )
}
